export const IntroSection = () => {
  return (
    <section className="intro-section">
      <p className="section-label">Why financing, why now</p>

      <div>
        <h2>
          Your clients have the means. <em>Financing gives them the choice.</em>
        </h2>
        <div className="intro-body">
          <p>
            Home Design Guild designers work with financially confident
            homeowners - people who have the resources to invest in their
            homes. This isn&apos;t about affordability. It&apos;s about optionality.
          </p>
          <p>
            When you offer financing, you give clients a sophisticated cash-flow
            tool: the ability to channel capital into other investments,
            opportunities, or simply peace of mind - while still proceeding
            with the project they want, at the scale it deserves.
          </p>
          <p>
            Designers who offer financing consistently report higher average
            project values, fewer scope reductions mid-project, and clients who
            feel empowered rather than constrained.
          </p>
        </div>
      </div>
    </section>
  );
};
